import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryAllCoupons({ page, size, direction, sort, },) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-coupon`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

export function _addCoupon({ code, discount, expireAt, isActive },) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-coupon`,
    method: 'post',
    data: {
      code,
      discount,
      expireAt,
      isActive,
      // type,
      // amount,
      // currencyCode,
    }
  });
}

export function _deleteCoupon(couponId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-coupon`,
    method: 'delete',
    params: {
      couponId,
    },
  });
}

export function _updateCoupon(id, { code, discount, expireAt, isActive }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-coupon/${id}`,
    method: 'patch',
    data: {
      code,
      discount,
      expireAt,
      isActive,
      // type,
      // amount,
      // currencyCode,
    }
  });
}

export function _getCouponDetail(couponId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-coupon/detail`,
    method: 'get',
    params: {
      couponId
    }
  })
}
